// extracted by mini-css-extract-plugin
export default {"mainContainer":"section_mainContainer__rEGYE","title":"section_title__q+zXP","items":"section_items__Yldup"};